

import type { ReactNode } from 'react'

import Titlecontent from './Titlecontent'
import ExpertiseSection from './Expertisesection'

interface Service {
  img: string
  title: string
}

interface VisionandexpertiseProps {
  title: ReactNode
  content?: ReactNode
  service?: Service[]
}

export default function Visionandexpertise({
  title,
  content,
  service = [],
}: VisionandexpertiseProps) {
  return (
    <section className="py-5 md:py-10 bg-white">
      <div className="container mx-auto">
        {/* Title Section */}
        <div className="grid grid-cols-12">
          <div className="title--head col-span-10 col-start-2 text-center">
            <Titlecontent
              title={title}
              content={content}
            />
          </div>
        </div>

        {/* Expertise Section */}
        <div className="mt-5">
          <ExpertiseSection services={service} />
        </div>
      </div>
    </section>
  )
}

